import CBRELogo from "@assets/images/cbreGreen.svg?react";

/**
 * PDF Footer Component
 * Standard CBRE disclaimer and logo footer for PDF pages
 */
const PDFFooter = () => (
  <div className="flex py-2 pr-2.5 pl-8 gap-x-3 items-center bg-primary-lighter pdf-grid-footer">
    <div className="text-[0.45rem] text-default">
      &copy; {new Date().getFullYear()} CBRE, Inc. We obtained the information
      above from sources we believe to be reliable. However, we have not
      verified its accuracy and make no guarantee, warranty or representation
      about it. It is submitted subject to the possibility of errors, omissions,
      change of price, rental or other conditions, prior sale, lease or
      financing, or withdrawal without notice. We include projections, opinions,
      assumptions or estimates for example only, and they may not represent
      current or future performance of the property. You and your tax and legal
      advisors should conduct your own investigation of the property and
      transaction.
    </div>
    <div>
      <CBRELogo className="h-3 text-primary" />
    </div>
  </div>
);

export default PDFFooter;
